import create from './create';
import deleteApi from './delete';
import edit from './edit';
import list from './list';

const ApiCall = {
  list,
  create,
  edit,
  delete: deleteApi,
};

export default ApiCall;
